<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { onMount } from 'svelte';

    // prettier-ignore
    let {
        src,
        width = 600,
        height = 480,
        x = 0,
        y = 0,
        onload,
        onerror
    } = $props();

    let href = $state();

    //need to postpone setting the href of image
    //because in Safari load event fires too quick in image is cached
    onMount(() => {
        href = src;
    });
</script>

<style>
    .svg-image {
        pointer-events: none;
    }
</style>

<image class="svg-image" {width} {height} {x} {y} preserveAspectRatio="none" {href} {onload} {onerror} />
